import FlowerTitle from "../components/ui/FlowerTitle";
import Button from "../components/ui/Button";
import { useState } from "react";

import { Pagination , Navigation, Autoplay} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";
import Modal from "../components/ui/Modal";

const Story = () => {

  const [page, setPage] = useState("story")
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="page-container">
      <nav className="page-nav">
        <Button text="Story" color="green" onClick={()=>setPage("story")}/>
        <Button text="Glossary" color="blue" onClick={()=>setPage("glossary")}/>
      </nav>
      {
        page === "story" ? <StoryPage/> : <Glossary/>
      }
      <nav className="page-nav">
        <Button text="Story" color="green" onClick={()=>{
          setPage("story")
          scrollToTop()
        }}/>
        <Button text="Glossary" color="blue" onClick={()=>{
          setPage("glossary")
          scrollToTop()
        }}/>
      </nav>
    </div>
  )
}

const StoryPage = () => (
  <>
    <FlowerTitle text="Story"/>
    <div className="story-wrapper">
      <p className="white-text">
        The Netherworlds of Hinomoto
      </p> 
      <p className="white-text">
        Hinomoto consists of a myriad of <span className="yellow-text">Netherworlds</span>. <br/>
        Vengeful ghosts boil forth from Haunt Springs,<br/>
        Sardemon World exists within a gargantuan space sardine,<br/>
        and Shicroaku's enticing tides are formed from countless demons, swirling together like seaweed...
      </p>
      <p className="white-text">
      In this land of diverse Netherworlds,<br/>
        many of the inhabitants once adhered to a code at odds with their demonic nature–bushido.
      </p>
      <p className="white-text">
      But that was all long ago.<br/>
        When Demmodore Opener and his Netherarmy arrived, Hinomoto changed.
      </p>
      <p className="white-text">
      The demons of Hinomoto now live under the Hinomoto Code of Destruction enacted by Opener...
      </p>

      <div className="decree-container">        
        <p className='code-of-destruction'>Hinomoto Code of Destruction</p>

        <p className='decree'>
          Decree #1 – Bushido: BUST IT TO BITS!<br/>
          Decree #2 – Someone unhappy with taxes or wages? KILL 'EM TO DEATH.<br/>
          Decree #3 – Friendship and love: HARD PASS.<br/>
          Decree #4 – Boost strength, crush weakness? YES, PLEASE.<br/>
          Decree #5 – Fighting makes the Netherworld go ‘round. GO FOR IT!
        </p>

        <p className='decree'>
        Anyone who disobeys these laws gets HARAKIRI’d.
        </p>
      </div>
      <p className="white-text">
      Today, the land's noble warriors are but a memory.
      </p>
      <p className="white-text">  
      Our tale is set in these worlds that have lost their pride.<br/>
        It is about a girl who adores bushido–and a boy who hates it.<br/>
        Now, they must join forces to fight for one another's beliefs...
      </p>
    </div>
  </>
)

const Glossary = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    size: 8
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="glossary_ss_0.jpg"/>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          The Hinomoto Netherworlds
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <div className="slide-wrapper">
            <Swiper
              slidesPerView={1}
              autoplay={true}
              pagination={true}
              loop={true}
              modules={[ Pagination, Navigation, Autoplay ]}
              className="mySwiper"
            >
              <SwiperSlide>
                <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_01.jpg`} alt="" className="ss" 
                  onClick={()=>{
                    setModal(
                      {
                        ...modal,
                        'visible': true,
                        'current': 1,
                      }
                    )
                  }}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_02.jpg`} alt="" className="ss"
                  onClick={()=>{
                    setModal(
                      {
                        ...modal,
                        'visible': true,
                        'current': 2,
                      }
                    )
                  }}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_03.jpg`} alt="" className="ss"
                  onClick={()=>{
                    setModal(
                      {
                        ...modal,
                        'visible': true,
                        'current': 3,
                      }
                    )
                  }}
                />
              </SwiperSlide>
            </Swiper>
            </div>
          </div>
          <div className="item">
            <p className="white-text item-text">
              This cluster of diverse Netherworlds believed in a highly venerated code: bushido. However, that's all in the past. Hardly a trace of honor remains in the Hinomoto Netherworlds today. Their pride, their livelihood, their bushido... All of these were taken from them by a cunning Netherworld invader: Demmodore Opener.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Ewwdo Netherworld
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_01.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 1,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_02.jpg`} alt="" className="ss"
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
              }}
            />
          </div>
        </div>
        <p className="white-text item-text pair-text">
          The shogunate rules Hinomoto from Ewwdo Castle, which is located in this Netherworld.<br/>
          The town is surrounded by appalling slums.
        </p>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Yokohorror Netherworld
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_04.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 4,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              A stylish town, heavily influenced by outside tastes.<br/>
              The ruling family's villa is here, where the current shogun, Yeyasu, parties constantly...
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Sardemon World
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_02.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              Located inside a gigantic space sardine.<br/>
              This world boasts the largest hauls of fish in any Netherworld ever, but the once-bustling fishing towns now suffer under Ocean Magistrate Sea Again's crushing sardine tax.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Casinomoto Netherworld
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_05.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 5,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              Fortunes are won and lost every day in this government-run gambler's paradise.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Gero Haunt Springs
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_06.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 6,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              One of Hinomoto's Big Three Haunt Springs.<br/>
              The haunt springs boil with ghostly grudges, and their glistening waters can even revive the dead.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          The Seven Founding Weapons--Legendary Soul-Powered Artifacts
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_07.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 7,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              Scattered across Hinomoto, the mythic Seven Founding Weapons are imbued with souls.<br/>
              Only users who resonate with a weapon's soul may wield it--but once a bond is formed, the wielder can strike with deity-destroying power!
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          The Hinomoto Code of Destruction
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <p className="white-text item-text pair-text">
          Demmodore Opener's regime enacted this decree after his invasion.<br/>
          It bans bushido, with violations punishable by the dreaded act of harakiri!
          In the face of this decree, Hinomoto's warriors had no choice but to abandon their bushido code.
        </p>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text" style={{marginTop: '25px'}}>
          The 13 Magistrates
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_08.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 8,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text">
              Opener's lackeys, who work to suppress bushido across Hinomoto.
              Big Bull, the Protection Magistrate, runs security on land; Ocean Magistrate Sea Again handles Hinomoto's oceans; Foreseeing Magistrate Suisen can predict the future...and there are many other equally dangerous enemies in their ranks! A clash with the shogunate guarantees a showdown with these individuals...
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default Story;